import assign from 'latest_modules/lodash/assign';
import Product from '../schema/Product';

import productsApi from '../../api/products';
import { PRODUCTS as productsTypes } from '../mutation-types';

const state = () => new Product().toObject();

const getters = {};

const actions = {
  /*
  Set a product data
  @param {Object} payload
  */
  setData({ commit, dispatch }, payload) {
    commit(productsTypes.DATA_RECEIVED, payload);
    if (payload.skus) {
      return dispatch('skus/setData', payload.skus);
    } else {
      return Promise.resolve();
    }
  },

  /*
  Fetch a product data with skus data
  @param {Object} payload
  @param {String} payload._id - Product id
  */
  fetchOne({ dispatch }, payload) {
    return new Promise(function (resolve, reject) {
      productsApi.fetchOne(
        {
          _id: payload._id,
          is_cart_empty: payload.is_cart_empty,
          is_login: payload.is_login,
          premium_plan_welcome_point: payload.premium_plan_welcome_point,
          premium_plan_recontract_extra_point:
            payload.premium_plan_recontract_extra_point,
          has_welcoming_gift_coupon: payload.has_welcoming_gift_coupon
        },
        function (err, res) {
          if (err) {
            return reject(err);
          }
          dispatch('setData', res).then(resolve, reject);
        }
      );
    });
  }
};

const mutations = {
  [productsTypes.DATA_RECEIVED](state, payload) {
    assign(state, new Product(payload).toObject());
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
